import zeeLoginPage from '@/components/LoginPage.vue';
import zeePurchaseOrders from '@/components/purchase-orders/PurchaseOrders.vue';
import zeeSuppliers from '@/components/suppliers/Suppliers.vue';
import zeePayments from '@/components/payments/Payments.vue';
import zeePurchaseOrderDetails from '@/components/purchase-orders/purchase-order/PoDetails.vue';
import zee404 from '@/components/404.vue';
import zeeSignupPage from '@/components/SignupPage.vue';
import zeeReceivables from '@/components/receivables/Receivables.vue';
import zeeReceivableDetails from '@/components/receivables/receivable/receivable-details/ReceivableDetails.vue';

function idToNumber(route) {
  return { id: parseInt(route.params.id, 10) };
}

const routes = [{
  path: '/purchase-orders',
  name: 'home',
  component: zeePurchaseOrders,
  meta: {
    requiresAuth: true,
    pageTitle: 'Purchase Orders',
  },
},
{
  path: '/',
  redirect: '/purchase-orders',
},
{
  path: '/suppliers',
  name: 'suppliers',
  component: zeeSuppliers,
  meta: {
    requiresAuth: true,
    pageTitle: 'Suppliers',
  },
},
{
  path: '/payments',
  name: 'payments',
  component: zeePayments,
  meta: {
    requiresAuth: true,
    pageTitle: 'Payments Transactions',
  },
},
{
  path: '/receivables',
  name: 'receivables',
  component: zeeReceivables,
  meta: {
    requiresAuth: true,
    pageTitle: 'Receivables Transactions',
  },
},
{
  path: '/login',
  name: 'login',
  components: {
    'login-view': zeeLoginPage,
  },
},
{
  path: '/signup',
  components: {
    'signup-view': zeeSignupPage,
  },
},
{
  name: 'po-detail',
  path: '/purchase-orders/:id/details',
  component: zeePurchaseOrderDetails,
  meta: {
    requiresAuth: true,
    pageTitle: 'Purchase Order Details',
  },
  props: idToNumber,
},
{
  name: 'rt-detail',
  path: '/receivables/:id/details',
  component: zeeReceivableDetails,
  meta: {
    requiresAuth: true,
    pageTitle: 'Receivable Details',
  },
  props: true,
},

{
  path: '/404',
  component: zee404,
},
{
  path: '*',
  redirect: '/404',
},
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js